import { type ReactNode } from 'react';
import { Button, type ButtonProps } from '@/ui_v3';
type CardButtonProps = ButtonProps & {
  icon: ReactNode;
};
export const QuizListItemHoverButton = ({
  icon,
  children,
  ...rest
}: CardButtonProps) => {
  return <Button size={'md'} rounded={'full'} className={'invisible w-auto group-hover:visible'} {...rest} onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    rest.onClick?.(e);
  }} data-sentry-element="Button" data-sentry-component="QuizListItemHoverButton" data-sentry-source-file="QuizListItemHoverButton.tsx">
      <div className={'flex gap-3xs'}>
        {icon}
        {children}
      </div>
    </Button>;
};